// Confidence values returned by the LLM in
// state.naturalSearch.confidence. The reducer, the thunk, the V2
// bridge, and the chip rail all need to key off the same strings.
export const CONFIDENCE_HIGH = 'high';
export const CONFIDENCE_NEEDS_CLARIFICATION = 'needs_clarification';

// URL param keys used to persist NL state across page reloads so chip
// rail + input rehydrate from a bookmarked / refreshed link.
export const NL_URL_PARAMS = {
    QUERY: 'nlq',
    CONFIDENCE: 'nlc',
    GROUNDED: 'nlg',
};

// CSV tokens for resolvedContext flags in the URL.
export const NL_GROUNDED_TOKENS = {
    UTR: 'utr',
    LOCATION: 'location',
    AGE: 'age',
    GENDER: 'gender',
};

const GROUNDED_KEY_BY_TOKEN = {
    [NL_GROUNDED_TOKENS.UTR]: 'usedSinglesUtr',
    [NL_GROUNDED_TOKENS.LOCATION]: 'usedHomeLocation',
    [NL_GROUNDED_TOKENS.AGE]: 'usedAge',
    [NL_GROUNDED_TOKENS.GENDER]: 'usedGender',
};

const TOKEN_BY_GROUNDED_KEY = Object.entries(GROUNDED_KEY_BY_TOKEN)
    .reduce((acc, [token, key]) => ({ ...acc, [key]: token }), {});

export function encodeGroundedContext(resolvedContext) {
    if (!resolvedContext) {
        return '';
    }
    return Object.entries(resolvedContext)
        .filter(([, on]) => Boolean(on))
        .map(([key]) => TOKEN_BY_GROUNDED_KEY[key])
        .filter(Boolean)
        .join(',');
}

export function decodeGroundedContext(csv) {
    if (!csv) {
        return null;
    }
    const out = {};
    csv.split(',').forEach((token) => {
        const key = GROUNDED_KEY_BY_TOKEN[token];
        if (key) {
            out[key] = true;
        }
    });
    return Object.keys(out).length > 0 ? out : null;
}

/**
 * Did a new natural-language search land between the prev and current
 * sentinel snapshots? Each NL apply increments
 * state.naturalSearch.appliedSentinel by one (see
 * naturalSearchReducer.js); consumers compare their own "last seen"
 * snapshot against the current value to detect an NL-driven transition
 * and either short-circuit or run NL-aware logic.
 */
export function didNaturalSearchTransition(prevSentinel, currentSentinel) {
    return (currentSentinel ?? 0) > (prevSentinel ?? 0);
}
